import { Request } from '~src/httpClient/serverApi/requests/Request';

import { IContentRelayPlanDetail, ISelectionQuery } from '../types/ISelectionQuery';

/**
 * Parameters for the VizPortal `updatePlan` Web Client method
 * (WebClientContentMobilityAppService.updatePlan).
 *
 * IMPORTANT: `updateMask` carries snake_case field names (AIP-134 partial update). When it is
 * omitted/empty the server performs a FULL replace of every updatable field. To change only the
 * membership, pass `updateMask: ['selection_queries']` and the complete desired `selectionQueries`
 * set — selection queries are always replaced wholesale, never appended.
 */
export interface IUpdateContentRelayPlanParams {
  luid: string;
  name?: string;
  description?: string;
  selectionQueries: ISelectionQuery[];
  updateMask: string[];
}

export class UpdateContentRelayPlanRequest extends Request<IUpdateContentRelayPlanParams, IContentRelayPlanDetail> {
  constructor(params: IUpdateContentRelayPlanParams) {
    super('updatePlan', params);
  }
}
